"use client";

import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OTCHistoryDetailsView from "../../MedicalHistory/views/scriptHistoryDetails.jsx";

export default function PriceScriptSummaryView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { scriptData, scriptFile } = location.state || {};

  const [localScriptUrl, setLocalScriptUrl] = useState(null);

  useEffect(() => {
    try { sessionStorage.setItem("cameFromPriceSummary", "1"); } catch {}
    return () => {
      // do not clear here; Form will clear after using this marker
    };
  }, []);

  // If a script file was uploaded on the previous page, create a temporary
  // object URL so the embedded history/details view can immediately open it
  // via the "Script" -> "View" action, before anything is persisted.
  useEffect(() => {
    if (!scriptFile) {
      setLocalScriptUrl(null);
      return;
    }
    const url = URL.createObjectURL(scriptFile);
    setLocalScriptUrl(url);
    return () => {
      try {
        URL.revokeObjectURL(url);
      } catch {
        // ignore revoke errors
      }
    };
  }, [scriptFile]);

  const scriptDataForView = useMemo(
    () => ({
      ...(scriptData || {}),
      // Prefer the freshly uploaded file, then any scriptDocUrl/docurl coming
      // from navigation or backend.
      scriptDocUrl:
        localScriptUrl || scriptData?.scriptDocUrl || scriptData?.docurl || null,
    }),
    [scriptData, localScriptUrl]
  );

  const props = {
    scriptData: scriptDataForView,
    showTotalItems: false,
    invoiceActionLabel: "",
    hideRadios: true,
    hideMedicationLabel: true,
    hidePackageLabel: true,
    deliveryLabelText: "Submit Claim",
    onDeliveryAction: () => navigate("/customer/dispensary/script/submit-claim/customer-details", { state: { scriptData, scriptFile } }),
    centerTopControls: true,
    hidePharmacist: true,
    hidePractitioner: true,
    paymentTypeAsInput: true,
    rowsPerPage: 1000,
    // For price-script summary, we are previewing a draft, not an existing
    // persisted prescription. Avoid fetching remote script details by
    // treating the script number as an id.
    disableRemoteScriptDetails: true,
  };

  return (
    <>
      <OTCHistoryDetailsView {...props} />
    </>
  );
}